// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Layout
import Layout from './components/layout/Layout';

// Pages
import HomePage from './pages/HomePage';
import ToursPage from './pages/ToursPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import SingleBlogPost from './pages/SingleBlogPost';
import WaiverPage from './pages/WaiverPage';

// Booking Flow Pages
import TourDetailPage from './pages/booking/TourDetailPage';
import BookingFlow from './pages/booking/BookingFlow.js';
import WaiverSigningPage from './pages/WaiverSigningPage';
import TicketVerificationPage from './pages/TicketVerificationPage';

//404 Page
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/tours" element={<ToursPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<SingleBlogPost />} />
          <Route path="/waiver/:token" element={<WaiverSigningPage />} />
          <Route path="/waiver" element={<WaiverPage />} />

          {/* Tour & Booking Flow */}
          <Route path="/tours/:slug" element={<TourDetailPage />} />
          <Route path="/booking/:bookingRef" element={<BookingFlow />} />
          <Route path="/verify-ticket" element={<TicketVerificationPage />} />
          {/* <Route path="/booking/:bookingRef/details" element={<BookingDetailsPage />} />
          <Route path="/booking/:bookingRef/waivers" element={<WaiverSigningPage />} />
          <Route path="/booking/:bookingRef/payment" element={<PaymentPage />} />
          <Route path="/booking/:bookingRef/confirmation" element={<ConfirmationPage />} /> */}
          {/* 404 - Must be last */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;